module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#environment",
      toString: function () {
        return this.url;
      }
    }